$(document).ready(function () {

    /// UI v1

    ub.funcs.ui = {};

    ub.funcs.ui.getAllNames = function (materialOptionName) {

        var _names      = [];
        var _obj        = _.find(ub.data.modifierLabels, {name: materialOptionName});

        if (typeof _obj !== "undefined") {
            var _name       = _obj.fullname;
            var _otherSide  = '';

            _names.push(_name);

            if (!ub.data.hasSeparatedSleeve.check(ub.config.material_id) && !ub.data.hasSeparatedSleeve.checkSport(ub.config.sport)) {
                if (_name.indexOf('left') >-1 && _name.indexOf('body') === -1) {
                    _match      = _name.replace('left', 'right');
                    _names.push(_match);
                }

                if (_name.indexOf('right') >-1 && _name.indexOf('body') === -1) {
                    _match      = _name.replace('right', 'left');
                    _names.push(_match);
                }
            }

            // This is use to return a material option that has `left`, or `right` and 'body' on the '_name' variable.
            // example: `left_body_panel`,  `front_right_body_panel`
            ub.data.bodyOnMaterialOption.hasBlockPattern(ub.config.blockPattern, ub.config.option, function() {
                let mergeColorBlockPatterns = ["Lacrosse Jersey", "Crossbody Equipment Bag"];
                let mergeColorIds = [6910, 6916, 6922, 11940];

                if (_name.indexOf('left') > -1 && _name.indexOf('body') > -1) {
                    _match = _name.replace('left', 'right');
                    _names.push(_match);
                }

                if (_name.indexOf('right') > -1 && _name.indexOf('body') > -1) {
                    _match = _name.replace('right', 'left');
                    _names.push(_match);
                }
                if (_.contains(mergeColorBlockPatterns, ub.config.blockPattern) || _.contains(mergeColorIds, ub.config.material_id)) {
                    if (_name.indexOf('front') > -1 && _name.indexOf('body') > -1) {
                        _match = _name.replace('front', 'back');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back') > -1 && _name.indexOf('body') > -1) {
                        _match = _name.replace('back', 'front');
                        _names.push(_match);
                    }
                    if (_name.indexOf('top_panel') > -1) {
                        _match = _name.replace('top_panel', 'back_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_panel') > -1) {
                        _match = _name.replace('back_panel', 'top_panel');
                        _names.push(_match);
                    }
                }
                let mergeColorOption = ['VISIE Hybrid Jersey', 'VISIE Hybrid Short', '2 Ply Reversible Jersey Sleeveless Women'];
                if (_.contains(mergeColorOption, ub.config.option)) {
                    if (_name.indexOf('front') > -1 && _name.indexOf('body') > -1) {
                        _match = _name.replace('front', 'back');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back') > -1 && _name.indexOf('body') > -1) {
                        _match = _name.replace('back', 'front');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'back_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_panel') > -1) {
                        _match = _name.replace('back_panel', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_panel') > -1) {
                        _match = _name.replace('back_panel', 'front_body');
                        _names.push(_match);
                    }
                }

                let mergeBaseballBlockPatterns = ['Perforated Baseball Tapered Pant', 'Perforated Baseball Traditional Pant', 'Perforated Fastpitch Pants', 'Perforated Football Pant', 'Pro Pant', 'Walk Off Perforated Pant', "RPO Pant"];
                if (ub.config.sport === 'Track and Field' && ub.config.option === 'Decathlon Shorts' || (_.contains(mergeBaseballBlockPatterns, ub.config.blockPattern))) {
                    if (_name.indexOf('back_right_leg') > -1) {
                        _match = _name.replace('back_right_leg', 'front_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_right_leg') > -1) {
                        _match = _name.replace('back_right_leg', 'front_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_right_leg') > -1) {
                        _match = _name.replace('back_right_leg', 'crotch');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_right_leg') > -1) {
                        _match = _name.replace('back_right_leg', 'belt_loops');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_left_leg') > -1) {
                        _match = _name.replace('back_left_leg', 'front_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_left_leg') > -1) {
                        _match = _name.replace('back_left_leg', 'front_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_left_leg') > -1) {
                        _match = _name.replace('back_left_leg', 'crotch');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_left_leg') > -1) {
                        _match = _name.replace('back_left_leg', 'belt_loops');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_left_leg') > -1) {
                        _match = _name.replace('front_left_leg', 'back_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_left_leg') > -1) {
                        _match = _name.replace('front_left_leg', 'back_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_left_leg') > -1) {
                        _match = _name.replace('front_left_leg', 'crotch');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_left_leg') > -1) {
                        _match = _name.replace('front_left_leg', 'belt_loops');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_right_leg') > -1) {
                        _match = _name.replace('front_right_leg', 'back_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_right_leg') > -1) {
                        _match = _name.replace('front_right_leg', 'back_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_right_leg') > -1) {
                        _match = _name.replace('front_right_leg', 'crotch');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_right_leg') > -1) {
                        _match = _name.replace('front_right_leg', 'belt_loops');
                        _names.push(_match);
                    }
                    if (_name.indexOf('crotch') > -1) {
                        _match = _name.replace('crotch', 'front_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('crotch') > -1) {
                        _match = _name.replace('crotch', 'front_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('crotch') > -1) {
                        _match = _name.replace('crotch', 'back_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('crotch') > -1) {
                        _match = _name.replace('crotch', 'back_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('crotch') > -1) {
                        _match = _name.replace('crotch', 'belt_loops');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_waistband') > -1) {
                        _match = _name.replace('back_waistband', 'front_waistband');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_waistband') > -1) {
                        _match = _name.replace('front_waistband', 'back_waistband');
                        _names.push(_match);
                    }
                }

                if (_.contains(mergeBaseballBlockPatterns, ub.config.blockPattern)) {
                    if (_name.indexOf('back_belt_tunnel') > -1) {
                        _match = _name.replace('back_belt_tunnel', 'left_belt_tunnel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_belt_tunnel') > -1) {
                        _match = _name.replace('back_belt_tunnel', 'right_belt_tunnel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_tunnel') > -1) {
                        _match = _name.replace('left_belt_tunnel', 'back_belt_tunnel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_tunnel') > -1) {
                        _match = _name.replace('left_belt_tunnel', 'right_belt_tunnel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_tunnel') > -1) {
                        _match = _name.replace('right_belt_tunnel', 'left_belt_tunnel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_tunnel') > -1) {
                        _match = _name.replace('right_belt_tunnel', 'back_belt_tunnel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_loop_1') > -1) {
                        _match = _name.replace('left_belt_loop_1', 'left_belt_loop_2');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_loop_1') > -1) {
                        _match = _name.replace('left_belt_loop_1', 'right_belt_loop_1');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_loop_1') > -1) {
                        _match = _name.replace('left_belt_loop_1', 'right_belt_loop_2');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_loop_2') > -1) {
                        _match = _name.replace('left_belt_loop_2', 'left_belt_loop_1');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_loop_2') > -1) {
                        _match = _name.replace('left_belt_loop_2', 'right_belt_loop_1');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_belt_loop_2') > -1) {
                        _match = _name.replace('left_belt_loop_2', 'right_belt_loop_2');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_loop_1') > -1) {
                        _match = _name.replace('right_belt_loop_1', 'left_belt_loop_1');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_loop_1') > -1) {
                        _match = _name.replace('right_belt_loop_1', 'left_belt_loop_2');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_loop_1') > -1) {
                        _match = _name.replace('right_belt_loop_1', 'right_belt_loop_2');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_loop_2') > -1) {
                        _match = _name.replace('right_belt_loop_2', 'left_belt_loop_1');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_loop_2') > -1) {
                        _match = _name.replace('right_belt_loop_2', 'left_belt_loop_2');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_belt_loop_2') > -1) {
                        _match = _name.replace('right_belt_loop_2', 'right_belt_loop_1');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_pocket_welt') > -1) {
                        _match = _name.replace('left_pocket_welt', 'right_pocket_welt');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_pocket_welt') > -1) {
                        _match = _name.replace('right_pocket_welt', 'left_pocket_welt');
                        _names.push(_match);
                    }
                }

                let mergeBaseballBlockPatternsJersey = ['Perforated Baseball Jersey', 'Perforated Baseball Jersey ', 'Perforated Jersey Set-in', 'Walk Off Perforated Jersey'];
                if (_.contains(mergeBaseballBlockPatternsJersey, ub.config.blockPattern)) {
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('collar_back') > -1) {
                        _match = _name.replace('collar_back', 'left_front_collar');
                        _names.push(_match);
                    }
                    if (_name.indexOf('collar_back') > -1) {
                        _match = _name.replace('collar_back', 'right_front_collar');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_front_collar') > -1) {
                        _match = _name.replace('left_front_collar', 'collar_back');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_front_collar') > -1) {
                        _match = _name.replace('left_front_collar', 'right_front_collar');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_front_collar') > -1) {
                        _match = _name.replace('right_front_collar', 'collar_back');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_front_collar') > -1) {
                        _match = _name.replace('right_front_collar', 'left_front_collar');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_sleeve') > -1) {
                        _match = _name.replace('left_sleeve', 'right_sleeve');
                        _names.push(_match);
                    }
                    if (_name.indexOf('right_sleeve') > -1) {
                        _match = _name.replace('right_sleeve', 'left_sleeve');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_graphic') > -1) {
                        _match = _name.replace('front_graphic', 'back_graphic');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_graphic') > -1) {
                        _match = _name.replace('back_graphic', 'front_graphic');
                        _names.push(_match);
                    }
                }

                let blockPatternsRPOJersey = ['Perforated Football Jersey', 'RPO Jersey'];
                if (_.contains(blockPatternsRPOJersey, ub.config.blockPattern)) {
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'front_bottom_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_bottom_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'front_bottom_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'back_bottom_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_bottom_panel') > -1) {
                        _match = _name.replace('front_bottom_panel', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_bottom_panel') > -1) {
                        _match = _name.replace('front_bottom_panel', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_bottom_panel') > -1) {
                        _match = _name.replace('front_bottom_panel', 'back_bottom_panel');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_bottom_panel') > -1) {
                        _match = _name.replace('back_bottom_panel', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_bottom_panel') > -1) {
                        _match = _name.replace('back_bottom_panel', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_bottom_panel') > -1) {
                        _match = _name.replace('back_bottom_panel', 'front_bottom_panel');
                        _names.push(_match);
                    }
                }
                
                var cheerNeckOptions = ['Top Sleeveless', ' Top Sleeveless Open Back', 'Top Sleeveless Open Back', 'Top Sleeveless Racerback', 'Basic Top', 'Open Back Top', 'Racerback Top'];
                if (_.contains(cheerNeckOptions, ub.config.option)) {
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_upper_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'back_upper_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_upper_body') > -1) {
                        _match = _name.replace('back_upper_body', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_upper_body') > -1) {
                        _match = _name.replace('back_upper_body', 'back_body');
                        _names.push(_match);
                    }
                }

                var cheerSkort = ['Cheer Skort', 'Cheer Skirt', 'Cheer Bottom'];
                if (_.contains(cheerSkort, ub.config.blockPattern)) {
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'waistband');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'waistband');
                        _names.push(_match);
                    }
                    if (_name.indexOf('waistband') > -1) {
                        _match = _name.replace('waistband', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('waistband') > -1) {
                        _match = _name.replace('waistband', 'back_body');
                        _names.push(_match);
                    }
                }

                var cheerMockNeckOptions = ['Top Long Sleeve Mock Neck', 'Top Long Sleeve V-Neck', 'Long Sleeve Mock Neck Liner', 'Long Sleeve V-Neck Liner'];
                if (_.contains(cheerMockNeckOptions, ub.config.option)) {
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'neck');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'neck');
                        _names.push(_match);
                    }
                    if (_name.indexOf('neck') > -1) {
                        _match = _name.replace('neck', 'front_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('neck') > -1) {
                        _match = _name.replace('neck', 'back_body');
                        _names.push(_match);
                    }
                }

                var cheerLowerMen = ['Pant', 'Short'];
                if (ub.config.blockPattern === 'Cheer Bottom' && _.contains(cheerLowerMen, ub.config.option)) {
                    if (_name.indexOf('back_right_leg') > -1) {
                        _match = _name.replace('back_right_leg', 'front_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_right_leg') > -1) {
                        _match = _name.replace('back_right_leg', 'front_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_left_leg') > -1) {
                        _match = _name.replace('back_left_leg', 'front_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_left_leg') > -1) {
                        _match = _name.replace('back_left_leg', 'front_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_left_leg') > -1) {
                        _match = _name.replace('front_left_leg', 'back_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_left_leg') > -1) {
                        _match = _name.replace('front_left_leg', 'back_right_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_right_leg') > -1) {
                        _match = _name.replace('front_right_leg', 'back_left_leg');
                        _names.push(_match);
                    }
                    if (_name.indexOf('front_right_leg') > -1) {
                        _match = _name.replace('front_right_leg', 'back_right_leg');
                        _names.push(_match);
                    }
                }

                if (ub.config.blockPattern === 'Cheer Top Men') {
                    if (_name.indexOf('front_body') > -1) {
                        _match = _name.replace('front_body', 'back_body');
                        _names.push(_match);
                    }
                    if (_name.indexOf('back_body') > -1) {
                        _match = _name.replace('back_body', 'front_body');
                        _names.push(_match);
                    }
                }
                
                let blockPatternsCheerPant = ['Compression Pant'];
                if (_.contains(blockPatternsCheerPant, ub.config.blockPattern)) {
                    if (_name.indexOf('left_leg') > -1) {
                        _match = _name.replace('left_leg', 'front_waistband');
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_leg') > -1) {
                        _match = _name.replace('left_leg', 'back_waistband'); 
                        _names.push(_match);
                    }
                    if (_name.indexOf('left_leg') > -1) {
                        _match = _name.replace('left_leg', 'gusset');
                        _names.push(_match);
                    }
                }
            });
        }

        return _names;

    };

    // Set Color in the Settings Object
    ub.funcs.setMaterialOptionSettingsColor = function (materialOptionCode, colorObj, source) {

        var _type                       = ub.current_material.material.type;
        var _uniformObject              = ub.current_material.settings[_type];
        var _materialOptionObject       = _.find(_uniformObject, {code: materialOptionCode});
            // patch for Saved Design: 71059
            _materialOptionObject       = ub.dataPatches.patchSavedDesign71059MaterialOptionObject(materialOptionCode, _materialOptionObject);

        if (typeof _materialOptionObject !== 'undefined') {

            if (_materialOptionObject.color !== parseInt(colorObj.hex_code, 16)) {

                var _oldValue = _materialOptionObject.color;
                var _newValue = parseInt(colorObj.hex_code, 16);

                if (source !== 'from undo') {

                    if (typeof ub.funcs.pushOldState === "undefined") { return; } 

                    ub.funcs.pushOldState('color change', 'material option', _materialOptionObject, _materialOptionObject.colorObj, colorObj);

                }

            }

            _materialOptionObject.color     = parseInt(colorObj.hex_code, 16);
            _materialOptionObject.colorObj  = colorObj;

        }

    };

    // Change Matching Part (e.g. for Waistband, Prolook on Compression Pants)
    ub.funcs.ui.setMatchingColor = function (materialOptionCode, colorObj, source) {

        var _isCoordinating = ub.data.coordinatingColors.isCoordinating(materialOptionCode.toTitleCase(), 
                    ub.config.sport,
                    ub.config.blockPattern, 
                    ub.config.option,
                    colorObj.color_code);

        if (_isCoordinating.result) {

            var _matchingPartColorObj = ub.funcs.getColorByColorCode(_isCoordinating.matchingPartColor);
            var _matchingPartCode = _isCoordinating.matchingPart.toCodeCase();

            ub.funcs.setMaterialOptionSettingsColor(_matchingPartCode, _matchingPartColorObj, source);
            if (ub.data.afterLoadCalled !== 1) { return; }
            ub.change_material_option_color16(_matchingPartCode, parseInt(_matchingPartColorObj.hex_code, 16));

        }

    }

    // Set Color of the Actual Sprite in the stage
    ub.funcs.ui.setMaterialOptionColor = function (name, colorObj, source) {

        var _names = ub.funcs.ui.getAllNames(name);

        _.each(_names, function (name) {

            ub.funcs.setMaterialOptionSettingsColor(name, colorObj, source);
            ub.funcs.ui.setMatchingColor(name, colorObj, source);

            if (ub.data.afterLoadCalled !== 1) { return; }

            ub.change_material_option_color16(name, parseInt(colorObj.hex_code, 16));

        });

    };

    ub.funcs.setTeamColorByID = function (teamColorID, colorObj) {

        var _teamColorObj = ub.current_material.settings.team_colors;
        _teamColorObj[teamColorID - 1] = colorObj;

        var _removedHash  = colorObj.hex_code.replace('#', '');

        ub.funcs.setGroupColor(teamColorID.toString(), _removedHash, colorObj);

    };
    
    ///  material_option:    Body, etc...
    ///  type:               sublimated | non-sublimated

    ub.funcs.sublimationColorSet = function () {

        var _colorSet = _.pluck(_.filter(ub.data.colors, {sublimation_only: '1'}),'color_code');
        return _colorSet;

    }
    
    ub.funcs.ui.getColorSet = function (material_option, type) { 

        var _colorSet   = undefined; 
        var _colors     = undefined;

        _colorSet = _.find(ub.current_material.materials_options, { name: material_option, perspective: 'front'} );
        
        if (type === 'sublimated') {

            _colors = JSON.parse(_colorSet.sublimated_colors);              

        }
        else {

            _colors = JSON.parse(_colorSet.colors);

        }

        var _newColorSet = [];
        var _notFound = [];

        _.each (_colors, function (_color) {

            var _match = _.find(ub.data.colors, {color_code: _color});

            if (typeof _match === 'undefined') {
                _notFound.push(_color);
            }
            else {
                _newColorSet.push(_match);    
            }            

        });

        if (_notFound.length > 0) { ub.utilities.info("Can't find these assigned colors for " + material_option + ": " + _notFound.toString()); }

        return _newColorSet;

    };

    ub.funcs.restoreTeamColorSelectionsFromInitialUniformColors = function () {
        if (typeof window.ub.temp === "string") { return; }
        
        ub.front_view.alpha = 0;

        _sorted = _.sortBy(ub.data.colorsUsed, 'teamColorID');

        _.each(_sorted, function (_color) {
            $('button.change-color[data-color-code="' + _color.hexCode + '"]').click();
        });

        ub.funcs.drawColorPickers();

        ub.front_view.alpha = 1;
    }

    ub.funcs.restoreTeamColorSelections = function () {

        // if coming from saved customizations skip
        if (typeof window.ub.temp === "string") { return; }

        var _teamColorObject    = ub.current_material.settings.team_colors;
        var _teamColorSize      = _.size(ub.current_material.settings.team_colors);

        if (_teamColorSize === 0) { return; }

        _.each (_teamColorObject, function (teamColor) {

            var _selector       ='button.change-color[data-target="Team-color-picker"][data-color-id="' + teamColor.id + '"]';

            $(_selector).click();

        });

        ub.funcs.drawColorPickers();

    }

    ub.funcs.getBaseColors = function () {

        var _colorType      = '';
        var _factoryCode    = ub.current_material.material.factory_code;

        if (_factoryCode === 'pmp' ) {
            _colorType  = 'non-sublimated';
        }
        else {
            _colorType  = 'sublimated';
        }

        /// _colorSet   = ub.funcs.ui.getColorSet('Body', _colorType);

        if (_factoryCode === "PMP") {

            _colorSet = _.filter(ub.data.colors, {sublimation_only: "0"});

        } else {

            _colorSet = ub.data.colors;

        }

        if (QX7Rule.enabled && _.isEmpty(_colorSet)) {
            console.warn("base colors is empty. Using all data colors.");
            _colorSet = QX7Rule.colors;
        }

        // Hide Slate Gray in Color Picker for Stock Items
        if (ub.config.sport === "Stock Uniforms (Apparel)") {
            var reject_colors = ['FLG', 'FLB', 'SL', 'KH', 'HT', 'LV', 'SMG', 'SVB', 'SPH', 'SVN', 'SVRB', 'SVR', 'SHW', 'SI', 'SM', 'SVT', 'SEN', 'MCS'];
            _colorSet = _.filter(ub.data.colors, function(color) {
                return !_.contains(reject_colors, color.color_code);
            });

            if (ub.config.blockPattern === 'Lite') {
                var rejected_colors = ['FLG', 'FLB', 'SL', 'KH', 'HT', 'LV', 'SMG', 'SVB', 'SPH', 'SVN', 'SVRB', 'SVR', 'SHW', 'SI', 'SM', 'SVT', 'SEN', 'MCS'];
                const filteredColors = _.filter(ub.data.colors, (color, index) => index < 56 || index === 115);
                _colorSet = _.filter(ub.data.colors, function(color) {
                    return _.contains(filteredColors, color) && !_.contains(rejected_colors, color.color_code);
                });
            }
            if (ub.current_material.material.factory_code === 'HCM') {
                var hcm_rejected_colors = ['GR'];
                _colorSet = _.filter(ub.data.colors, function(color) {
                    return !_.contains(hcm_rejected_colors, color.color_code) && !_.contains(reject_colors, color.color_code);
                });

                var removedItem = ub.data.colors[56];
                _colorSet = _.without(_colorSet, removedItem);
                _colorSet.splice(34, 0, removedItem);
            }
        } else {
            var reject_colors = ['FLG', 'FLB', 'SL', 'KH', 'HT'];
            _colorSet = _.filter(ub.data.colors, function(color) {
                return !_.contains(reject_colors, color.color_code);
            });
        }

        if (_.contains(ub.config.hide_color_by_factorycode.split(','), _factoryCode)) {
            _colorSet = _.filter(ub.data.colors, function(color) {
                return !_.contains(ub.config.hide_colors.split(','), color.color_code);
            });
        }

        // var blockPatternMD = ['Stock NL6010', '2023 Top Next Level 6010 Triblend', 'Lite'];

        // if (_.contains(blockPatternMD, ub.config.blockPattern)) {
        //     if (_.isEmpty(QX7Rule.materialColorSets)) {
        //         _colorSet = QX7Rule.colors;
        //     } else {
        //         _colorSet = QX7Rule.materialColorSets[0].colors
        //     }
        // }

        return _colorSet;

    };

    ub.funcs.tennGuardTemp = function (name) {

        var _name = '';

        if (name === 'Tennessee Orange') {
            _name = 'Tenn. Orange';
        }
        else{
            _name = name;
        }

        return _name;

    }

    function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
          
      var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

      return {

        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))

      };

    }

    function describeArc (x, y, radius, startAngle, endAngle) {

        var start = polarToCartesian(x, y, radius, endAngle);
        var end = polarToCartesian(x, y, radius, startAngle);
        var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";

        var d = [
            "M", start.x, start.y, 
            "A", radius, radius, 0, arcSweep, 0, end.x, end.y
        ].join(" ");

        return d;       

    }

    ub.funcs.clearTeamColors = function () {

        ub.current_material.settings.team_colors = [];

    }

    ub.funcs.hasPattern  = function (materialOption) {

        if (typeof materialOption.pattern === "undefined")              { return false; }
        if (typeof materialOption.pattern.pattern_obj === "undefined")  { return false; }
        if (materialOption.pattern.pattern_id === "blank")              { return false; }

        return true;

    }

    ub.funcs.getMaterialOptionsWithPattern = function () {

        var _uniformType        = ub.current_material.material.type; 
        var _materialOptions    = ub.current_material.settings[_uniformType];
        var _matches            = [];

        _.each(_materialOptions, function (materialOption){

            if (ub.funcs.hasPattern(materialOption)) {

                _matches.push(materialOption);

            };

        });

        return _matches;

    }

    ub.funcs.updatePatterns = function () {

        if (ub.data.afterLoadCalled !== 1) {return;}

        var _patterns = [];
        _materialOptionsWithPattern = ub.funcs.getMaterialOptionsWithPattern();

        _.each (_materialOptionsWithPattern, function (_materialOption) {

            var _mCode = '';
            _mCode = _materialOption.code;

            _.each(_materialOption.pattern.pattern_obj.layers, function (layer, idx) {

                var _teamColorID    = parseInt(layer.team_color_id);
                var _teamColor      = ub.funcs.getTeamColorObjByIndex(_teamColorID);

                if (typeof _teamColor === "undefined") {

                    _teamColor = ub.funcs.getColorObjByHexCode(layer.default_color);

                } 
                
                var _uniformType = ub.current_material.material.type;
                var _titleCode = _materialOption.code.toTitleCase();
                var _rootContainer = ub.current_material.containers[_uniformType][_titleCode];

                if (typeof _rootContainer !== 'undefined') {

                    if (typeof _rootContainer.containers !== 'undefined') {
                        
                        _container = _rootContainer.containers;  
                        
                        _.each(_container, function (val){

                            layer.color = parseInt(_teamColor.hex_code, 16);
                            layer.color_code = _teamColor.color_code;
                            layer.default_color = _teamColor.hex_code;

                            val.container.children[idx].tint = layer.color;

                        });

                    }

                } 
 
            });

        });

    }

    ub.funcs.addColorToTeamColors = function (colorObj, cancelColorPickerUpdate) {

        var _teamColorObj = ub.current_material.settings.team_colors;
        var _result       = _.find(_teamColorObj, {color_code: colorObj.color_code});

        if (typeof _result !== "undefined") { return; } // exit if color already exist on _teamColorObj

        _teamColorObj.push(colorObj); 

        if (typeof cancelColorPickerUpdate === "undefined") {
            if (ub.data.afterLoadCalled) { ub.funcs.drawColorPickers(); }
        }
        
    };

    ub.funcs.ifColorIsUsedOnPatterns = function (colorObj) {

        var _result = false; 

        if (ub.data.afterLoadCalled !== 1) {return;}

        _materialOptionsWithPattern = ub.funcs.getMaterialOptionsWithPattern();

        _.each(ub.current_material.settings[ub.config.type], function (item) {
 
            if (typeof item.pattern !== "undefined") {
 
                if (item.pattern.pattern_id !== "" && item.pattern.pattern_id !== "blank") {

                    _.each(item.pattern.pattern_obj.layers, function (item) {
                        
                        colorItem = ub.funcs.getColorObjByHexCode(item.default_color);
                        
                        // Is Used
                        if (colorItem.id === colorObj.id) { _result = true; }

                    });

                }

            }

        });

        return _result;

    };

    ub.funcs.removeColorFromTeamColors = function (colorObj) {

        var _teamColorObj       = ub.current_material.settings.team_colors;
        var _indexOfColorObj    = undefined;

        var color = _.find(ub.current_material.settings.team_colors, {color_code: colorObj.color_code});
        var _indexOfColorObj = _.indexOf(_teamColorObj, color);

        if (_indexOfColorObj !== -1) {
            _teamColorObj.splice(_indexOfColorObj, 1);
        }

        ub.funcs.drawColorPickers();

        // Selective execution here ... Update pattern only if the color being removed is currently in used by the pattern
        if (ub.funcs.ifColorIsUsedOnPatterns(colorObj)){ ub.funcs.updatePatterns(); }
    };

    ub.funcs.drawColorPickers = function () {

        if (QX7Rule.enabled) {
            ub.funcs.QX7DrawColorPickers();
            return;
        }

        var _teamColorObj           = ub.current_material.settings.team_colors;
        var _strBuilder             = '';
        var _sortedModifierLabels   = _.sortBy(ub.data.modifierLabels, 'index');
        var _tempIndex              = 1;
        var _colorSet               = ub.funcs.getBaseColors();

        _strBuilder                 += '<div id="color-wheel-container">';

            _.each(_sortedModifierLabels, function (modLabel) {

                var fill = 'white';

                _strBuilder     += '<div class="color-wheel" id="cw_' + modLabel.index + '">';
                _strBuilder     += '<svg id="svg_cw_' + modLabel.index + '" class="svg-color-wheel">';
                _tempIndex      += 1;
                _strBuilder     += '<circle class="preview growCircle" cx="275" cy="215" r="100"  fill="#3d3d3d" />';
                _strBuilder     += '<text class="previewColorCode growTextCode" x="275" y="215" font-family="Avenir Next LT W04 Thin" font-size="48px" text-anchor="middle" fill="' + fill + '"></text>';
                _strBuilder     += '<text class="previewColorName growTextName" x="275" y="240" font-family="Avenir Next LT W04 Bold" font-size="18px" text-anchor="middle" fill="' + fill + '"></text>';


                /// Process Limited Colorset
                
                var _colorSet = undefined;
                var _limitedColorSet = ub.data.materialOptionWithLimitedColors.getLimitedColorSet(modLabel.name);

                if (typeof _limitedColorSet !== "undefined") {

                    _alternateColorSet = [];

                    _.each(_limitedColorSet.valid_colors, function (item) {

                        _alternateColorSet.push(ub.funcs.getColorByColorCode(item));

                    });

                    ub.utilities.info ('Limited Color Set detected for ' + modLabel.name);
                    _colorSet = _alternateColorSet;

                }

                if (typeof _limitedColorSet === "undefined") {
                    _colorSet = ub.current_material.settings.team_colors;
                }

                /// End Process Limited Colorset

                _.each(_colorSet, function (colorObj, index) {
                    // Only Update Material Option Colors when colors selected is less than the colors used count, to prevent updating uniform colors in case the user is just adding another color
                    if ((_.size(ub.current_material.settings.team_colors) < _.size(ub.data.colorsUsed)) && ub.config.isReversible !== "1") {
                        if (typeof ub.config.savedDesignInfo === "undefined") {
                            ub.funcs.setGroupColor((index + 1).toString(), colorObj.hex_code, colorObj); 
                        }
                    }

                    _strBuilder +=  '<path class="growStroke arc-' + modLabel.fullname + '" id="arc' + index + '-' + modLabel.fullname + '" data-color-id="' + colorObj.id + '" fill="none" stroke="#' + colorObj.hex_code + '" stroke-width="50" />'; 
                });

                _strBuilder     += '</svg>';
                _strBuilder     += '</div>';

            });

        _strBuilder         += '</div>';

        $('div#primary_options_container > div#cw').html(_strBuilder);

        _.each(_sortedModifierLabels, function (modLabel) {

            var _elements   = _teamColorObj.length;
            var _length     = 360 / _elements;
            var _start      = 0;

            /// Process Limited Colorset
                
            var _colorSet = undefined;
            var _limitedColorSet = ub.data.materialOptionWithLimitedColors.getLimitedColorSet(modLabel.name);

            if (typeof _limitedColorSet !== "undefined") {

                _alternateColorSet = [];

                _.each(_limitedColorSet.valid_colors, function (item) {

                    _alternateColorSet.push(ub.funcs.getColorByColorCode(item));

                });

                ub.utilities.info ('Limited Color Set detected for ' + modLabel.name);

                _colorSet = _alternateColorSet;

                _elements   = _alternateColorSet.length;
                _length     = 360 / _elements;

            }

            if (typeof _limitedColorSet === "undefined") {
                _colorSet = ub.current_material.settings.team_colors;
            }

            /// End Process Limited Colorset

            _.each(_colorSet, function (colorObj, index) {

                var _nth    = index;
                var _start  = _nth * _length;
                var _end    = _start + _length;
                var _id     = "arc" + index + '-' + modLabel.fullname;

                document.getElementById(_id).setAttribute("d", describeArc(275, 215, 150, _start, _end));

                $("path#arc" + index + '-' + modLabel.fullname).parent().find('circle').css('cursor', 'pointer');
                $("path#arc" + index + '-' + modLabel.fullname).parent().find('circle').on('click', function () {

                    $('div.pd-dropdown-links[data-fullname="team-colors"]').trigger('click');

                });

                $("path#arc" + index + '-' + modLabel.fullname).parent().find('text.previewColorName').css('cursor', 'pointer');
                $("path#arc" + index + '-' + modLabel.fullname).parent().find('text.previewColorName').on('click', function () {

                    $('div.pd-dropdown-links[data-fullname="team-colors"]').trigger('click');

                });

                $("path#arc" + index + '-' + modLabel.fullname).parent().find('text.previewColorCode').css('cursor', 'pointer');
                $("path#arc" + index + '-' + modLabel.fullname).parent().find('text.previewColorCode').on('click', function () {

                    $('div.pd-dropdown-links[data-fullname="team-colors"]').trigger('click');

                });

                $("path#arc" + index + '-' + modLabel.fullname).css('cursor','pointer');

                $("path#arc" + index + '-' + modLabel.fullname).on("click", function () {

                    $("path.arc-" + modLabel.fullname).attr("class", "growStroke arc-" + modLabel.fullname);
                    $(this).attr("class", "selectedStroke growStroke arc-" + modLabel.fullname);

                   var _colorID           = $(this).data('color-id');
                   var _colorOBJ          = _.find(_colorSet, {id: _colorID.toString()});

                   // prevent SRE-990
                   if (index = ub.current_part) {    
                       modLabel = ub.funcs.getModifierByIndex(ub.current_part);
                   }
                   
                   // store the color in local storage
                   ub.funcs.setColorForLocalStorage(modLabel.name, _colorOBJ)
                   //end

                   ub.funcs.ui.setMaterialOptionColor(modLabel.name, _colorOBJ, 'from color picker');

                   // Prolook Logo conflicting part checker
                   ub.data.prolookLogo.conflictingPartCheck(ub.config.sport, modLabel.name, _colorOBJ.color_code);
   
                   var $previewCircle     = $(this).parent().find('circle');
                   $previewCircle.css('fill', '#' + _colorOBJ.hex_code);

                   if (_colorOBJ.color_code === 'W') {
                    
                        $previewCircle.css('fill', '#ffffff');

                   }

                   var fill = "white";

                   if (_colorOBJ.color_code === 'W' || _colorOBJ.color_code === 'Y' || _colorOBJ.color_code === 'CR' || _colorOBJ.color_code === 'S' || _colorOBJ.color_code === 'PK'  || _colorOBJ.color_code === 'OP' || _colorOBJ.color_code === 'SG' || _colorOBJ.color_code === 'FLG') {
                        fill = 'black';
                   }

                   var $previewColorCode = $(this).parent().find('text.previewColorCode');
                   $previewColorCode.html(_colorOBJ.color_code);
                   $previewColorCode.css('fill', fill);

                   var $previewColorName = $(this).parent().find('text.previewColorName');
                   $previewColorName.html(_colorOBJ.name);
                   $previewColorName.css('fill', fill);

                   let r, g, b, hsp;

                   if (ub.config.blockPattern === 'Polo Fusion' && modLabel.fullname === 'back_body') {
                        function lightOrDark(color) {

                            // Check the format of the color, HEX or RGB?
                            if (color.match(/^rgb/)) {
                        
                            // If HEX --> store the red, green, blue values in separate variables
                            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
                        
                            r = color[1];
                            g = color[2];
                            b = color[3];
                            } 
                            else {
                        
                            // If RGB --> Convert it to HEX: http://gist.github.com/983661
                            color = +("0x" + color.slice(1).replace( 
                                color.length < 5 && /./g, '$&$&'
                            )
                                    );
                        
                            r = color >> 16;
                            g = color >> 8 & 255;
                            b = color & 255;
                            }
                        
                            // HSP equation from http://alienryderflex.com/hsp.html
                            hsp = Math.sqrt(
                            0.299 * (r * r) +
                            0.587 * (g * g) +
                            0.114 * (b * b)
                            );
                        
                            // Using the HSP value, determine whether the color is light or dark
                            if (hsp>127.5) {
                                ub.objects.left_view.prolook_white.alpha = 0;
                                ub.objects.left_view.prolook_black.alpha = 1;
                                ub.objects.back_view.prolook_white.alpha = 0;
                                ub.objects.back_view.prolook_black.alpha = 1;
                                
                            return 'light color detected';
                            } 
                            else {
                                ub.objects.left_view.prolook_white.alpha = 1;
                                ub.objects.left_view.prolook_black.alpha = 0;
                                ub.objects.back_view.prolook_white.alpha = 1;
                                ub.objects.back_view.prolook_black.alpha = 0;
                            return 'dark color detected';
                            }
                        }
                        bgColor = _colorOBJ.hex_code;
                        brightness = lightOrDark(bgColor);
                        console.log(brightness + ' On Color Wheel');
                    }

                });

            });

        });    

        var _sizeOf     = _.size(ub.data.modifierLabels);
        var _widthOfCW  = $('div.color-wheel').first().width();

        $('#color-wheel-container').css('width', (_sizeOf * _widthOfCW) + 'px');
    };

    ub.funcs.getSettingsByMaterialOptionCode = function (materialOptionCode) {

        var _type                   =  ub.current_material.material.type;
        var _uniformSettings        =  ub.current_material.settings[_type];
        var _materialOptionSettings =  _.find(_uniformSettings, {code: materialOptionCode});

        return  _materialOptionSettings;

    };

    ub.funcs.getModifierByIndex = function (index) {

        var _modifier = _.find(ub.data.modifierLabels, {index: index});
        return _modifier;

    };

    ub.funcs.getColorObjByHexCode = function (hexCode) {

        var _baseColors = ub.funcs.getBaseColors();
        var _colorObj;

        if (typeof hexCode === 'undefined') {

            _colorObj = ub.funcs.getBaseColors()[0];
            
        } else {

            _colorObj   = _.find(_baseColors, {hex_code: hexCode.lpad("0",6).toString()});

        }

        return _colorObj;

    };

    ub.funcs.getColorByColorCode = function (colorCode) {

        // var code = (colorCode == "DR") ? 'RB' : colorCode; // SRE-326: Convert DR to RB
        var code = colorCode;
        var _colorObj = _.find(ub.data.colors, {color_code: code });

        if (typeof _colorObj === "undefined") {
            
            if (colorCode !== "none") {
                console.error('Cant find colorCode ' + colorCode); // Only log if not none, none comes from turned off piping layers, when not in pipng its disabled colors e.g. Y, need to print those for the GA's
            }
            
            _colorObj = _.first(ub.data.colors);

        }

        if (colorCode == 'none') {

                _colorObj = {
                    forecolor: 'none',
                    color_code: 'none',
                    hex_code: 'none',
                    name: 'None',
                };
        }

        if (_colorObj.name === "White" || _colorObj.name === "Yellow" || _colorObj.name === "Cream" || _colorObj.name === "Safety Green") {

            _colorObj.forecolor = '3d3d3d';

        }
        else {

            _colorObj.forecolor = 'ffffff';

        }

        return _colorObj;

    }

    ub.funcs.moveToColorPickerByIndex = function (index) {

        $('div#single_team-color-picker').hide(); 
        $('div#cw').fadeIn();

        if (index === -1) { return; }
    

        var _index              = index + 1;
        var _modifier           = ub.funcs.getModifierByIndex(_index);
        var _materialSettings   = ub.funcs.getSettingsByMaterialOptionCode(_modifier.fullname);
            // patch for Saved Design: 71059
            _materialSettings   = ub.dataPatches.patchSavedDesign71059MaterialSettings(_modifier.fullname, _materialSettings);

        if(typeof _materialSettings !== 'undefined'){
            var _intColor           = _materialSettings.color;
            var _hexCode            = (_intColor).toString(16);
            var colorObj = ub.funcs.getColorObjByHexCode(_hexCode);

            // search by color code instead (hexcode changed fix)
            if (typeof colorObj === "undefined") {
                colorObj            =  ub.funcs.getColorByColorCode(_materialSettings.colorObj.color_code);
            }

            if (typeof colorObj === 'undefined') {

                util.log("Can't find color: "  + _hexCode);

            }

            var $svgPath = $('svg#svg_cw_' + (_index) + ' > path[data-color-id="' + colorObj.id +'"]');

            $svgPath.trigger('click');

            var _widthOfCW  = $('div.color-wheel').first().width();
            var _leftMargin = _widthOfCW * (_index - 1);

            $('#color-wheel-container').css('margin-left', '-' + _leftMargin + 'px');

            // Check pattern if enabled in part
            if (typeof _materialSettings.has_pattern !== 'undefined') {
                let { has_pattern } = _materialSettings;
                var $patternButton = $('.footer-buttons.change-view[data-view="patterns"]');

                if (has_pattern) {
                    // console.warn(_modifier.name + ' - pattern is on');
                    $patternButton.show();
                } else {
                    console.warn(_modifier.name + ' - pattern is off');
                    $patternButton.hide();
                }
                var offPattern = ['Bottom Hem', 'Sleeve End']
                if (_.contains(offPattern, _modifier.name)) {
                    if (ub.config.blockPattern === 'Hoodie') {
                        console.warn(_modifier.name + ' - pattern is off');
                        $patternButton.hide();
                    }
                }
            }
        }

    };

    ub.funcs.showTeamColorPicker = function (index) {

        $('div#single_team-color-picker').fadeIn();
        $('div#cw').hide();

    };

    ub.data.initialized = false;

    ub.funcs.getTeamColorIndexByColorID = function (colorID) {

        var _indexFound = undefined;
        var _ctr = 0;

        _.each(ub.current_material.settings.team_colors, function (team_color) {
            
            if (parseInt(team_color.id) === parseInt(colorID)){

                _indexFound = _ctr;        

            }

            _ctr += 1;

        });

        return _indexFound;

    }

    ub.funcs.initTeamColors = function () {
        var _colorSet = '';

        if (QX7Rule.enabled) {
            let defaultFabric = QX7Rule.defaultFabric;
            let fabricObject = QX7Rule.Fabrics.getFabric(defaultFabric);

            if (_.isUndefined(fabricObject)) {
                _colorSet = ub.funcs.getBaseColors();
                console.warn("Cannot find default fabric")
            } else {
                console.log(`Using the colors of this fabric ${fabricObject.fabric_code}`)
                // Temporily override rule for Stock Polo uniforms. Ref PRL-836
                ub.config.blockPattern == 'Stock Polo' ? _colorSet = ub.funcs.getBaseColors() : _colorSet = fabricObject.colors;
            }
        } else {
            // If `thread_colors` value is true in ub.current_material.settings
            // then use thread colors instead of the default colors
            if (ub.current_material.settings.threadColors) {
                _colorSet =  _.sortBy(ub.data.threadColors, 'order');
            } else {
                _colorSet = ub.funcs.getBaseColors();

                // hide FLB and FLG colors on Team Colors UI
                if (ub.config.blockPattern === 'Flag Football') {
                    var flag_colors = ['FLB', 'FLG'];
                    _colorSet = _.filter(ub.data.colors, function(color) {
                        return !_.contains(flag_colors, color.color_code);
                    });
                }
            }

            // if (ub.current_material.settings.twillColors) {
            //     if (_.isEmpty(ub.data.twillColors)) {
            //         _colorSet =  _.uniq(_.sortBy(ub.data.twillColors, 'order'));
            //     }
            // }
        }

        // var blockPatternMD = ['Stock NL6010', '2023 Top Next Level 6010 Triblend', 'Lite'];
        // if (_.contains(blockPatternMD, ub.config.blockPattern)) {
        //     $("span.part_label").html('Apparel Colors');
        // } else {
            $("span.part_label").html('Team Colors');
        // }
        $("span.nOf").html('Select the colors you will use');
        $('div#primary_options_container').html('<div id="team-color-picker"></div><div id="cw"></div>');

        $('#team-color-picker').ubTeamColorPicker({
        
            target: 'team-color-picker',
            type: 'single',
            colorSet: _colorSet,
            factory: ub.current_material.material.factory_code,

        });

        ub.funcs.showTeamColorPicker();

        if (!ub.data.initialized) {
            ub.funcs.restoreTeamColorSelections();
            ub.data.initialized = true;
        } else {

            var colors_btn = util.dataSelector('.btn', { 'elid': 'single_team-color-picker' });

            // return only the designated team colors by brand
            ub.current_material.settings.team_colors = ub.current_material.settings.team_colors.filter( function (team_color) {
                return team_color.brand === ub.config.brand.toLocaleLowerCase() || team_color.brand == ub.config.brand;
            });

            _.each(ub.current_material.settings.team_colors, function (color, index) {
                // SRE 311: Because the team color in the saved design is 4 color however the color used is only 2
                // if (typeof window.ub.temp === "string") {
                //     let usedColor = _.find(ub.data.colorsUsed, {hexCode: color.hex_code});

                //     if (typeof usedColor === "undefined") {
                //         return;
                //     }
                // }

                var color_btn = util.dataSelector('.btn', { 'elid': 'single_team-color-picker', 'color-label': color.color_code });
                
                if (typeof color_btn !== 'undefined') { 
                    color_btn.attr('data-status', 'selected');
                }
            });


            var s = undefined;
            colors_btn.each( function() {
                
                if ($(this).data('status') === 'selected') {
                    var _colorID = $(this).data('color-id');
                    s = ub.funcs.getTeamColorIndexByColorID(_colorID);
                    s = parseInt(s) + 1;

                    $(this).first().html(s);
                }
            });
        }
    }

    ub.funcs.isInTeamColor = function (colorCode) {
    
        var _result = _.find(ub.current_material.settings.team_colors, {color_code: colorCode});

        return (typeof _result !== 'undefined');

    };

    // diff is the result of _.difference(ub.data.colors, ub.current_material.settings.team_colors)
    // or all colors thats not added to ... settings.team_colors
    // but only add after the initial team colors is setup first

    ub.funcs.addAllColorToTeamColors = function () {
    
        var _baseColors = ub.funcs.getBaseColors();
        var _diffColors = _.difference(_baseColors, ub.current_material.settings.team_colors);

        _.each (_diffColors, function (colorObj) {

            var $btnSelector = $('button[data-target="Team-color-picker"][data-color-label="' + colorObj.color_code + '"]');
            var color        = $btnSelector.data('color');
            var colorID      = $btnSelector.data('color-id');
            var colorStatus  = $btnSelector.data('status');
            var colorCode    = $btnSelector.data('color-code');
            var colorLabel   = $btnSelector.data('color-label');
            var _index       = ub.current_material.settings.team_colors.length + 1;

            $btnSelector.first().data('status','selected');
            $btnSelector.first().html('<i class="fa fa-check" aria-hidden="true"></i>');
            $btnSelector.first().html(_index);

            if (colorLabel === 'W' || colorLabel === 'Y' || colorLabel === 'CR' || colorLabel === 'S' || colorLabel === 'PK'  || colorLabel === 'OP' || colorLabel === 'SG') {                
                $btnSelector.first().css('color', '#3d3d3d');
                $btnSelector.first().css('text-shadow', '1px 1px #d7d7d7');
            }

            ub.funcs.addColorToTeamColors(colorObj);

        });

    }

    ub.funcs.changeTeamColorsArray = function(teamColorsArray) {
        if(_.isArray(teamColorsArray)) {
            ub.current_material.settings.team_colors = teamColorsArray;
        }
    }

    /**
    * @desc set the active team colors in the team color picker without triggering the click event;
    * @return void
    */
    ub.funcs.setActiveColorsOnTeamColorPanel = function() {
        var teamColors = ub.current_material.settings.team_colors;
        var $changeColorBtn = $("button.change-color");

        $changeColorBtn.text("");
        $changeColorBtn.attr("data-status", "unselected");

        _.each(teamColors, (color, index) => {
            $("button.change-color[data-color-id='"+color.id+"']")
            .attr("data-status", "selected")
            .data("status", "selected")
            .text(index+1);
        });

        ub.funcs.drawColorPickers();
    }

    /**
     *
     * QX7 FUNCS
     *
     */

     ub.funcs.QX7DrawColorPickers = function () {
        const template = _.template($('#qx7-modifier-color-pickers').html());
        let modifierLabels = QX7Rule.ModifierLabel.getLabels();
        const factoryCode = ['MDJ'];

        $('div#primary_options_container > div#cw').html(template({
            labels: modifierLabels,
            factoryCode: _.contains(factoryCode, ub.current_material.material.factory_code),
        }));

        _.each(modifierLabels, (modLabel) => {
            const colorsSet = modLabel.colors;
            var _elements = modLabel.colors.length;
            var _length = 360 / _elements;

            _.each(colorsSet, (colorObj, index) => {
                var _nth = index;
                var _start = _nth * _length;
                var _end = _start + _length;

                const $arcElement = document.getElementById(`arc${index}-${modLabel.code}`);
                const svgPath = `path#arc${index}-${modLabel.code}`;
                const btnMDJ = `button#arc${index}-${modLabel.code}`;
                const $svgPathParent = $(svgPath)?.parent();
                const $teamColorsDropdown = $('div.pd-dropdown-links[data-fullname="team-colors"]');

                $arcElement?.setAttribute("d", describeArc(275, 215, 150, _start, _end));

                $svgPathParent.find('circle').css('cursor', 'pointer');
                $svgPathParent.find('circle').on('click', function() {
                    $teamColorsDropdown.click();
                });

                $svgPathParent.find('text.previewColorName').css('cursor', 'pointer');
                $svgPathParent.find('text.previewColorName').on('click', function() {
                    $teamColorsDropdown.click();
                });

                $svgPathParent.find('text.previewColorCode').css('cursor', 'pointer');
                $svgPathParent.find('text.previewColorCode').on('click', function() {
                    $teamColorsDropdown.click();
                });

                $(svgPath).css('cursor','pointer');
                $(svgPath).on("click", function () {

                    $(`path.arc-${modLabel.code}`).attr("class", `growStroke arc-${modLabel.code}`);
                    $(this).attr("class", "selectedStroke growStroke arc-" + modLabel.code);

                    const colorID = $(this).data('color-id');
                    const colorObj = _.find(colorsSet, {id: colorID.toString()});

                    QX7Rule.BodyPart.changeGroupColor(modLabel.name, colorObj, (isChanged) => {
                        if (isChanged) {
                            console.log("Color Successfully changed for " + modLabel.name);

                            // [Stock Item] Change Color BrandLogo Color - Hard Coded Rule
                            if (ub.isStockItem && modLabel.name === "Body") {
                                const brandLogoColor = ub.data.stockItemLogoColor.getBrandColor(colorObj.color_code);
                                if (brandLogoColor) {
                                    console.warn(`[Stock Item] Change Prolook logo color to ${brandLogoColor.color_alias}`);
                                    ub.funcs.ui.setMaterialOptionColor("Prolook", brandLogoColor, 'from color picker');
                                }
                            }
                        }
                    });

                    var $previewCircle = $(this).parent().find('circle');
                    $previewCircle.css('fill', '#' + colorObj.hex_code);

                    if (colorObj.color_code === 'W') {
                        $previewCircle.css('fill', '#ffffff');
                    }

                    const BLACK_FILL_COLORS = ['W','Y','CR','S','PK','OP','SG','FLG'];
                    let fill = BLACK_FILL_COLORS.includes(colorObj.color_code) ? "black" : "white";

                    const $previewColorCode = $(this).parent().find('text.previewColorCode');
                    $previewColorCode?.html(colorObj.color_code);
                    $previewColorCode?.css('fill', fill);

                    const $previewColorName = $(this).parent().find('text.previewColorName');
                    $previewColorName?.html(colorObj.name);
                    $previewColorName?.css('fill', fill);

                });

                $(btnMDJ).css('cursor','pointer');
                $(btnMDJ).on("click", function () {

                    $(`button.arc-${modLabel.code}`).attr("class", `growStroke arc-${modLabel.code}`);
                    $(this).attr("class", "growStroke btn arc-" + modLabel.code);

                    const colorID = $(this).data('color-id');
                    const colorObj = _.find(colorsSet, {id: colorID.toString()});

                    QX7Rule.BodyPart.changeGroupColor(modLabel.name, colorObj, (isChanged) => {
                        if (isChanged) {
                            console.log("Color Successfully changed for " + modLabel.name);

                            // [Stock Item] Change Color BrandLogo Color - Hard Coded Rule
                            if (ub.isStockItem && modLabel.name === "Body") {
                                const brandLogoColor = ub.data.stockItemLogoColor.getBrandColor(colorObj.color_code);
                                if (brandLogoColor) {
                                    console.warn(`[Stock Item] Change Prolook logo color to ${brandLogoColor.color_alias}`);
                                    ub.funcs.ui.setMaterialOptionColor("Prolook", brandLogoColor, 'from color picker');
                                }
                            }
                        }
                    });

                    // Monster Digital
                    if (ub.current_material.material.factory_code === 'MDJ') {
                        _.each(ub.views, view => {
                            const viewObject = ub.objects[`${view}_view`];
                            const settings = ub.current_material.settings[ub.config.type];
                            const current_material = ub.current_material.settings;
                            const adult_vendor_style = ub.current_material.material.rule.vendor_styles.adult_vendor_style;
                            const youth_vendor_style = ub.current_material.material.rule.vendor_styles.youth_vendor_style;
                    
                            if (_.isEmpty(viewObject)) return;
                    
                            _.each(viewObject, sprite => {
                                if (!sprite) return;
                    
                                // Adjust Draw Cord zIndex for Lite Hoodies
                                const partName = `${colorObj.name} ${'flat'} ${view}`.toCodeCase();
                                const partNameDrawCord = `${'draw cord'} ${colorObj.name} ${'flat'} ${'front'}`.toCodeCase();
                    
                                if (sprite.name === partNameDrawCord) {
                                    sprite.zIndex = -300;
                                }
                                // End adjust Draw Cord zIndex for Lite Hoodies

                                // console.log(partName)
                    
                                sprite.alpha = sprite.name === partName || sprite.name === partNameDrawCord ? 1 : 0
                    
                                _.each(settings, obj => {
                                    obj.alpha = obj.code === partName ? 1 : 0
                                })
                                // add vendor style in bc
                                current_material.adult_vendor_style = adult_vendor_style;
                                current_material.youth_vendor_style = youth_vendor_style;
                            })  
                        })
                    }
                    // End Monster Digital
                });
            });
        });

        // Change Color Picker
        var _sizeOf = _.size(modifierLabels);
        var _widthOfCW = $('div.color-wheel').first().width();
        $('#color-wheel-container').css('width', (_sizeOf * _widthOfCW) + 'px');

        if (ub.config.material_id === 12327) {
            $('#color-wheel-container').hide();
            $('div.color-wheel').hide();
        }
    }

     ub.funcs.QX7MoveToColorPickerByGroup = function(groupName) {
        // Hide Team Color Picker
        $('div#single_team-color-picker').hide();
        $('div#cw').fadeIn();

        const index = _.findIndex(QX7Rule.materialColorGroups, {"Body Part Group": groupName});
        const modifier = _.find(ub.data.modifierLabels, { rule_part_group: groupName})
        const matSettings = ub.funcs.getSettingsByMaterialOptionCode(modifier?.fullname);

        if (typeof matSettings !== 'undefined') {
            const colorObj = ub.funcs.getColorByColorCode(matSettings.colorObj.color_code);

            console.assert(colorObj, `Can't find color ${matSettings.colorObj.color_code}`);

            if (colorObj) {
                const $svgPath = $(`svg#svg_cw_${index} > path[data-color-id="${colorObj.id}"]`);
                $svgPath?.click();
            }
        }

        // Change Color Wheel
        const width = $('div.color-wheel').first().width();
        let leftMargin = width*(index+1 - 1);
        $('#color-wheel-container').css('margin-left', '-' + leftMargin + 'px');
    }

    ub.funcs.QX7ActivateColorPickerByGroup = function(groupName) {
        $('div#single_team-color-picker').hide();
        $('div#cw').fadeIn();

        if (groupName) {
            $(`div.pd-dropdown-links[data-fullname="${groupName}"]`)?.click();
        }
    }

    ub.funcs.initializeStockItemProlookLogo = function() {
        if (ub.isStockItem) {
            let color_code = _.find(ub.current_material.materials_options, { name: "Body"})?.default_color || "";

            if (color_code) {
                const brandLogoColor = ub.data.stockItemLogoColor.getBrandColor(color_code);
                if (brandLogoColor) {
                    console.warn(`[Stock Item] Change Prolook logo color to ${brandLogoColor.color_alias}`);
                    ub.funcs.ui.setMaterialOptionColor("Prolook", brandLogoColor, 'from color picker');
                }
            }
        }
    }

    ub.funcs.setColorForLocalStorage = function (modLabelName, color) {

        items = [
            {
                blockPattern: ["1-Ply Reversible"],
                sport: ["Basketball"]
            }
        ]
        _.find(items, item =>{

            if (_.contains(item.blockPattern, ub.config.blockPattern) && _.contains(item.sport, ub.config.sport)) {
              
                if (modLabelName === "Neck Binding") {
                    const newpart = JSON.stringify(modLabelName);
                    const newColor = JSON.stringify(color);
                    var showList = [];

                    let neck = {
                        part: modLabelName,
                        color: color
                    }
                    showList.push(neck);
                    localStorage.setItem("bindColorWithNeck", newColor);
                }

            }

            if (_.contains(item.blockPattern, ub.config.blockPattern) && _.contains(item.sport, ub.config.sport)) {
              
                if (modLabelName === "Arm Binding") {
                    const newpart = JSON.stringify(modLabelName);
                    const newColor = JSON.stringify(color);
                    var showList = [];

                    let arm = {
                        part: modLabelName,
                        color: color
                    }
                    showList.push(arm);
                    localStorage.setItem("bindColorWithArm", newColor);
                }

            }

        })
        
    };

});